import { h } from 'preact';
import { useState } from 'preact/hooks';


const PasteColors = ({ setColors, style }) => {
  const [val, setVal] = useState("");

  const updateColors = () => {
    const hexString = val.split("coolors.co/")[1];
    let newColors = hexString.split("-").map((el) => {
      return "#" + el.slice(0, 6);
    });
    setColors([...newColors]);
  }

  return (
    <div className={style.pasteBox}>
      <p>Pssst. Got a color scheme from <a href="https://coolors.co" target="_blank" rel="noopener noreferrer">coolors?</a> Paste the generator URL in here.</p>
      <div className={style.form}>
        <input value={val} onInput={(e) => setVal(e.target.value)} name="coolors"></input>
        <button onClick={updateColors} className={style.smallButton}>Ok!</button>
      </div>

    </div>
  )
}

export default PasteColors;